import React from 'react';

export const ScheduleRadioButton = React.memo((props) => {
  const { disabled, className, name, value, id, checked, onChange } = props;

  return (
    <input
      className={className}
      type="radio"
      id={id}
      value={value}
      disabled={disabled}
      name={name}
      checked={checked}
      onChange={onChange}
    />
  );
});

